import React from "react";
import Radium from "radium";
import EventListener from "react-event-listener";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventStore from "../stores/EventStore";
import EventActions from "../actions/EventActions";
import FilmActions from "../actions/FilmActions";
import LedgerStore from "../stores/LedgerStore";
import FilmStore from "../stores/FilmStore";
import UserStore from "../stores/UserStore";
import WorkingIndicator from "./partials/working-indicator.jsx";
import InjectedSelect from "./partials/injected-select.jsx";
import BoxOfficeReportView from "./partials/report-views/box-office-report-view.jsx";
import SummaryGridReportView from "./partials/report-views/summary-grid-report-view.jsx";
import DataGridReportView from "./partials/report-views/data-grid-report-view.jsx";
import InlineNoticeLabel from "./partials/inline-notice-label.jsx";
import VenueReportView from "./partials/report-views/venue-report-view.jsx";
import config from "../config"

import { Checkbox, Dialog, FlatButton, RadioButton, RadioButtonGroup, RaisedButton, Toggle } from "material-ui";

import Select from "react-select";
import "ag-grid-enterprise";

import { DateRangePicker, Calendar } from "react-date-range";
import { defaultStaticRanges } from "react-date-range/dist/defaultRanges";

import moment from "moment";
import VenueStore from "../stores/VenueStore";
import VenueActions from "../actions/VenueActions";

const boxOfficeGroups = [
  { value: "CINEMA WEEKLY", label: "Cinema Week (Fr-Th)" },
  { value: "STANDARD WEEKLY", label: "Standard Week (Su-Sa)" }
  // { value: "NO GROUPING", label: "No Grouping" }
];

const transactionLogGroups = [
  { value: "WEEKLY", label: "Weekly > Category" },
  { value: "MONTHLY", label: "Monthly > Category" },
  { value: "STANDARD WEEKLY", label: "Category > Weekly" },
  { value: "STANDARD MONTHLY", label: "Category > Monthly" },
  { value: "NO GROUPING", label: "No Grouping" }
];

class LedgerAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showRangeEditor: false,
      showSettingsPanel: true,
      allTime: true,
      range: {
        key: "selection",
        startDate: moment().subtract(1, "month"),
        endDate: moment()
      },
      reportType: null,
      reportName: null,
      grouping: "NO GROUPING",
      groupingName: "No Grouping",
      includeNameAndEmail: false,
      tType: [],
      tClass: [],
      useAdvanced: false,
      previousTransactions: [],
      selectedFilms: [],
      selectedBuckets: [],
      selectedVenueDate: new Date(),
      selectedVenue: null,
      viewSelectedBucket: null,
      viewSelectedFilms: [],
      viewAllTime: true,
      viewStartDate: moment().subtract(1, "month"),
      viewEndDate: moment(),
      viewGrouping: "NO GROUPING",
      //Temporary Export Path state variables
      downloadCSVOnly: false,
      showDownloadTempModal: false,
      processingReport: false,
      completedExport: null,
    };

    this.onWindowClick = this.onWindowClick.bind(this);
    this.onWindowKeyDown = this.onWindowKeyDown.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleReportSelection = this.handleReportSelection.bind(this);
    this.disableRunReportButton = this.disableRunReportButton.bind(this);
    this._checkTemporaryExport = this._checkTemporaryExport.bind(this);
    this.cancelModal = this.cancelModal.bind(this);
    this.buildBoxOfficeConditions = this.buildBoxOfficeConditions.bind(this);
    this.buildLedgerTransactionConditions = this.buildLedgerTransactionConditions.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  static getStores() {
    return [EventBucketStore, EventStore, FilmStore, LedgerStore, VenueStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getEventsForEventBucket: EventStore.getEventsForEventBucket,
      getLedgerAnalyticsTransactions:
        LedgerStore.getLedgerAnalyticsTransactions,
      getLedgerBoxOfficeTransactions:
        LedgerStore.getLedgerBoxOfficeTransactions,
      isFetching: LedgerStore.getState().isFetching,
      getAllUserFilms: FilmStore.getAllUserFilms,
      getVenuesForEventBucket: VenueStore.getVenuesForEventBucket,
      getVenueById: VenueStore.getVenueById,
      apiKey: UserStore.getState().apiKey
    };
  }

  onWindowClick(e) {
    if (
      this.state.showRangeEditor &&
      (!this.container ||
        (!this.container.contains(e.target) &&
          !this.rangeButton.contains(e.target)))
    ) {
      this.setState({ showRangeEditor: false });
    }
  }

  onWindowKeyDown(e) {
    if (this.state.showRangeEditor && e.which === 27) {
      // esc
      this.setState({ showRangeEditor: false });
    }
  }

  handleDateChange({ selection }) {
    if (selection.startDate === "all_time") {
      this.setState({
        allTime: true,
        showRangeEditor: false,
        range: this.state.range
      });
      return;
    }

    this.setState({ range: selection, allTime: false });
  }

  componentDidMount() {
    //On mount, load all the films for the Box Office Report select
    FilmActions.fetchAllForUser.defer();
  }

  componentWillReceiveProps(newProps, force = null) {
    if (force === true && this.state.showEventFilter) {
      EventActions.fetchAllForBucket(this.state.selectedBuckets);
    }
  }

  handleReportSelection(selectedItem) {
    const report = selectedItem.value;
    this.setState({
      reportType: selectedItem.value,
      reportName: selectedItem.label
    });

    switch (report) {
      case "box_office_report":
        this.setState({
          tType: [],
          tClass: [],
          grouping: boxOfficeGroups[0].value,
          groupingName: boxOfficeGroups[0].label
        });
        break;

      case "internal_summary":
        this.setState({
          tType: [],
          tClass: [{ value: "TICKET", label: "Ticket" }]
        });
        break;

      case "ledger_transaction_report":
        this.setState({
          tType: [],
          tClass: [],
          grouping: transactionLogGroups[0].value,
          groupingName: transactionLogGroups[0].label
        });
        break;

      case "venue_transaction_report":
        this.setState({
          tType: [],
          tClass: [],
          grouping: "",
          groupingName: "",
          allTime: false
        });
        break;

      default:
        break;
    }
  }

  formatFilms() {
    const allFilms = this.props.getAllUserFilms();
    const eventBuckets = this.state.selectedBuckets;

    if (eventBuckets === undefined) {
      return [];
    }

    const films = allFilms.reduce(function (filmArray, item) {
      if (item.name !== undefined && item.name !== "") {
        if (eventBuckets.length === 0) {
          filmArray.push({ value: item.id, label: item.name });
        } else {
          if (eventBuckets.includes(item.event_bucket)) {
            filmArray.push({ value: item.id, label: item.name });
          }
        }
      }
      return filmArray;
    }, []);

    return films;
  }

  formatVenues() {
    const venues = this.props.getVenuesForEventBucket(this.state.selectedBuckets);

    return venues.map((venue) => ({
      value: venue.id,
      label: venue.name
    }))
  }

  disableRunReportButton() {
    if (this.state.reportType === "ledger_transaction_report") {
      if (
        this.state.selectedBuckets === undefined ||
        this.state.selectedBuckets.length < 1
      ) {
        return true;
      }
    } else if (this.state.reportType === "box_office_report") {
      if (
        this.state.selectedBuckets === undefined ||
        this.state.selectedBuckets.length < 1 ||
        this.state.selectedFilms === undefined ||
        this.state.selectedFilms.length < 1
      ) {
        return true;
      }
    }

    return false;
  }

  cancelModal() {
    this.setState({
      showDownloadTempModal: false,
      processingReport: false,
      completedExport: null
    });
  }

  _checkTemporaryExport(id, wait) {
    setTimeout(() => {
      fetch(`${config.endpoint}temporary_exports/${id}?${UserStore.makeApiKeyQueryString()}`)
        .then(r => r.json())
        .then(e => {
          if (e.completed_at) {
            this.setState({ completedExport: e });
          } else {
            this._checkTemporaryExport(id, Math.min(4000, wait * 2)); // backoff: 500ms, 1s, 2s, 4s max wait
          }
        });
    }, wait);
  }

  buildBoxOfficeConditions() {
    const timezone = this.props.getEventBucketById(this.state.selectedBuckets)
      .timezone;

    let conditions = Object.assign({
      event_bucket: [this.state.selectedBuckets]
    });

    if (!this.state.allTime) {
      conditions.date = {
        $gt: moment.tz(this.state.range.startDate, timezone).startOf("day"),
        $lte: moment.tz(this.state.range.endDate, timezone).endOf("day")
      };
    }

    //TODO: Discuss with Theo about these values in the Box Office Report
    conditions["type"] = { $in: ["PAYMENT", "ADJUSTMENT", "REFUND"] };
    conditions["class"] = { $in: ["TICKET", "TAX"] };
    conditions.films = this.state.selectedFilms.map(item => {
      if (item.value) {
        return item.value;
      } else {
        return item;
      }
    });

    return conditions;
  }

  buildLedgerTransactionConditions() {
    let eventBuckets = this.state.selectedBuckets;
    if (typeof eventBuckets === "string") {
      eventBuckets = [eventBuckets];
    } else if (eventBuckets.length === 0) {
      eventBuckets = this.props.getEventBuckets().map(item => {
        return item.id;
      });
    }

    let conditions = Object.assign(
      {
        event_bucket: eventBuckets
      },
      !this.state.allTime && {
        date: {
          $gt: moment(this.state.range.startDate).startOf("day"),
          $lte: moment(this.state.range.endDate).endOf("day")
        }
      }
    );

    if (this.state.tType.length === 1) {
      conditions["type"] = this.state.tType[0].value;
    } else if (this.state.tType.length > 1) {
      const typeValues = this.state.tType.map(function (item) {
        return item.value;
      });
      conditions["type"] = { $in: typeValues };
    }

    if (this.state.tClass.length === 1) {
      conditions["class"] = this.state.tClass[0].value;
    } else if (this.state.tClass.length > 1) {
      const classValues = this.state.tClass.map(function (item) {
        return item.value;
      });
      conditions["class"] = { $in: classValues };
    }

    return conditions;
  }

  submitTemporaryExport() {
    const conditions = this.state.reportType === "box_office_report" ? this.buildBoxOfficeConditions() : this.buildLedgerTransactionConditions();

    const options = this.state.reportType === "box_office_report" ? {
      timePeriod: this.state.grouping,
    } : {
      timePeriod: this.state.grouping,
      includeNameAndEmail: this.state.includeNameAndEmail,
    }

    const url = `${config.endpoint}${this.state.reportType === "box_office_report" ? "analytics/box_office_temp_export" : "analytics/ledger_transaction_temp_export"}?${UserStore.makeApiKeyQueryString()}&conditions=${JSON.stringify(
      conditions
    )}&options=${JSON.stringify(options)}`;

    fetch(url, {
      method: 'POST',
    })
      .then(r => r.json())
      .then(d => {
        if (d.error || !d.temporary_export) {
          this.setState({
            completedExport: {
              error: d.error ? d.error.message : "An unknown error occurred"
            }
          });
        } else {
          this._checkTemporaryExport(d.temporary_export, 500);
        }
      });
  }

  getStyles() {
    return {
      rangeContainer: {
        float: "right",
        marginBottom: "1.25em"
      },
      rangeButton: {
        display: "inline-block",
        borderRadius: 20,
        padding: "8px 16px",
        fontSize: "12pt",
        color: "rgb(33,33,33)",
        cursor: "pointer",
        boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.1)",
        transition: "0.1s ease-in-out",
        ":hover": {
          boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.2)"
        }
      },
      overlay: {
        //position: "absolute",
        //right: 0,
        //top: 175,
        //left: 280,
        backgroundColor: "#fff",
        boxShadow: "0 0 5px 2px rgb(0,0,0,0.1)",
        zIndex: 99,
        marginTop: 10
      },
      overlaySubmit: {
        position: "absolute",
        right: 10,
        bottom: 10
      },
      summaryBarItem: {
        color: "#0288d1",
        fontWeight: "bold",
        fontSize: "16px"
      },
      summaryBarItemNowrap: {
        color: "#0288d1",
        fontWeight: "bold",
        fontSize: "16px",
        whiteSpace: "nowrap"
      },
      summaryBarSpacer: {
        color: "#0288d1",
        fontWeight: "bold",
        marginLeft: "20px",
        marginRight: "20px"
      },
      innerDialog: {
        maxWidth: 250,
        margin: "0 auto"
      }
    };
  }

  render() {
    const styles = this.getStyles(),
      eventBuckets = this.props.getEventBuckets();
    let events = null;

    if (this.state.showEventFilter) {
      const unprocessedEvents = this.props.getEventsForEventBucket(
        this.state.selectedBuckets
      );
      events = unprocessedEvents.map(e => {
        return {
          label: e.name,
          value: e.id,
          id: e.id
        };
      });
    }

    const isBoxOfficeFormat =
      this.state.reportType === "box_office_report" ||
      this.state.reportType === "internal_summary";
    const isReportSelected = this.state.reportType != null;

    if (!eventBuckets || eventBuckets.length === 0) {
      return <WorkingIndicator fullPage={true} />;
    }

    let timePeriod = this.state.allTime
      ? "All time"
      : moment(this.state.range.startDate)
          .twix(this.state.range.endDate, { allDay: true })
          .format({ implicitYear: false });

    const showSettings = this.state.showSettingsPanel
      ? {
          display: "inline-block",
          boxSizing: "border-box",
          width: "100%",
          marginTop: "10px",
          border: "1px solid #ededed",
          borderRadius: "1em",
          padding: "30px"
        }
      : { display: "none" };

    // GOD MODE OR CPH FILM FESTIVALS ONLY RIGHT NOW
    const includeVenueReport = UserStore.isGod() || UserStore.getUserId() === "63639dc6b1aa97002919a915";
    let reportOptions = [
      {
        value: "box_office_report",
        label: "Box Office Report by Film"
      },
      // Temporarily Removing
      //{
      //  value: "internal_summary",
      //  label: "Internal Weekly Summary"
      //},
      {
        value: "ledger_transaction_report",
        label: "Ledger Transaction Report"
      }
    ];
    if (includeVenueReport) {
      reportOptions.push(
        {
          value: "venue_transaction_report",
          label: "CPH Venue Transaction Report"
        }
      );
    }

    return (
      <div>
        <Dialog
          title={
            "Custom Ledger Report"
          }
          actions={[
            <FlatButton
              label={!this.state.processingReport ? "Close" : "Cancel"}
              onTouchTap={this.cancelModal}
            />
          ]}
          autoDetectWindowHeight={false}
          autoScrollBodyContent={false}
          bodyStyle={{ overflowY: "visible" }}
          open={!!this.state.showDownloadTempModal}
        >
          <div>
            {this.state.showDownloadTempModal ? ((
                this.state.completedExport ? (
                  this.state.completedExport.error ? (
                    <div>
                      <p>
                        Unfortunately, we ran into an error preparing your
                        report. Please try again, or contact us if the problem
                        persists.
                      </p>
                      <p>
                        <i>
                          Error:{" "}
                          <strong>{this.state.completedExport.error}</strong>
                        </i>
                      </p>
                    </div>
                  ) : (
                    <div>
                      <p>Great news, your report is ready!</p>
                      <p>
                        <strong>
                          {this.state.completedExport.description}
                        </strong>
                        <br />
                        <a
                          target="_blank"
                          href={this.state.completedExport.download_url}
                        >
                          <strong>Click here to download.</strong>
                        </a>
                      </p>
                    </div>
                  )
                ) : (
                  <div>
                    <WorkingIndicator centered={true} />
                    <p>
                      Your report is now being generated! This may take anywhere
                      from a few seconds to a few minutes. Keep this page open
                      and it will automatically update when your report is
                      ready.
                    </p>
                    <p>
                      Feel free to close this page. You will receive an email
                      with a download link as soon as your report has been
                      generated.
                    </p>
                  </div>
                )
              )

            ) : null}
          </div>
        </Dialog>
        <EventListener
          target="window"
          onClick={this.onWindowClick}
          onKeyDown={this.onWindowKeyDown}
        />

        <div style={{ position: "relative" }}>
          <h1 style={{ lineHeight: 1.2 }}>
            Custom Ledger Reporting{" "}
            <InlineNoticeLabel
              label="Limited beta"
              style={{ marginLeft: 10, verticalAlign: "middle" }}
            />
          </h1>

          <p style={{ fontStyle: "italic" }}>
            You have been invited to the early-access Eventive Ledger Preview.
            Eventive Ledger powers the next generation of Eventive financial
            reporting tools and will be launching soon. Some features are not
            yet fully supported &ndash; as an early-access tester, please{" "}
            <a href="mailto:ledgerfeedback@eventive.org">let us know</a> what
            reporting functionality would be most useful to you or if you run
            into any issues!
          </p>

          {this.state.showSettingsPanel ? null : (
            <div
              style={{
                width: "100%",
                paddingTop: "10px",
                display: "flex",
                justifyContent: "start"
              }}
            >
              <div style={styles.summaryBarItem}>{this.state.reportName}</div>
              <div style={styles.summaryBarSpacer}>|</div>
              {this.state.reportType !== "box_office_report" ? null : (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={styles.summaryBarItem}>
                    {this.state.selectedFilms.length < 1
                      ? "No Film Selected"
                      : this.state.selectedFilms.length > 1
                      ? "Multiple Films"
                      : this.state.selectedFilms[0].label}
                  </div>
                  <div style={styles.summaryBarSpacer}>|</div>
                </div>
              )}
              <div style={styles.summaryBarItemNowrap}>
                {this.state.allTime
                  ? "All Time"
                  : this.state.reportType ?
                    moment(this.state.selectedVenueDate).format("MMM DD")
                    : `${moment(this.state.range.startDate).format(
                      "MMM DD"
                    )} – ${moment(this.state.range.endDate).format("MMM DD")}`}
              </div>
              <div style={styles.summaryBarSpacer}>|</div>
              <div style={styles.summaryBarItemNowrap}>
                {this.state.reportType === "venue_transaction_report" ? this.props.getVenueById(this.state.selectedVenue).name : this.state.groupingName}
              </div>
              <div style={styles.summaryBarSpacer}> </div>
              <div style={{ flex: 1, textAlign: "right" }}>
                <RaisedButton
                  style={{ marginTop: "-10px", minWidth: 170 }}
                  onClick={e => {
                    this.setState({
                      showSettingsPanel: !this.state.showSettingsPanel
                    });
                  }}
                  label="Modify Settings"
                />
              </div>
            </div>
          )}

          <div id="report_settings" style={showSettings}>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <div style={{ flex: 1 }}></div>
              <div
                style={{
                  display: "none",
                  width: "80px",
                  marginLeft: "30px",
                  paddingTop: "20px",
                  flexDirection: "column",
                  textAlign: "right"
                }}
              >
                <div>Advanced</div>
                <Toggle
                  style={{
                    display: "inline-block",
                    width: 200,
                    paddingLeft: 25
                  }}
                  data-toggled={this.state.useAdvanced}
                  toggled={this.state.useAdvanced}
                  onToggle={(e, v) =>
                    this.setState({ useAdvanced: !this.state.useAdvanced })
                  }
                  name="advancedToggle"
                />
              </div>
            </div>

            {this.state.useAdvanced ? (
              <div style={{ height: "100px", padding: "20px" }}>
                <div>A different Query Editor will go here</div>
              </div>
            ) : (
              <div>
                <div
                  style={{
                    width: "400px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start"
                  }}
                >
                  <div
                    style={{
                      color: "#0288d1",
                      fontWeight: "bold",
                      fontSize: "14px",
                      paddingBottom: "5px"
                    }}
                  >
                    Report Type
                  </div>
                  <Select
                    clearable={false}
                    value={this.state.reportType}
                    onChange={this.handleReportSelection}
                    options={reportOptions}
                  />
                </div>

                {isReportSelected ? (
                  <div style={{ width: "100%", paddingTop: "25px" }}>
                    <div
                      style={{
                        color: "#0288d1",
                        fontWeight: "bold",
                        fontSize: "14px",
                        paddingBottom: "5px",
                        width: "100%"
                      }}
                    >
                      Event Bucket
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "start"
                      }}
                    >
                      <InjectedSelect
                        style={{ width: "400px" }}
                        placeholder={
                          this.state.reportType === "box_office_report" ||
                          this.state.reportType === "venue_transaction_report" ||
                          this.state.showEventFilter === true
                            ? "Select event bucket..."
                            : "Select event bucket(s)..."
                        }
                        clearable={false}
                        value={
                          (this.state.reportType === "box_office_report" ||
                            this.state.reportType === "venue_transaction_report" ||
                            this.state.showEventFilter === true) &&
                          this.state.selectedBuckets.length === 0
                            ? null
                            : this.state.selectedBuckets
                        }
                        types={["event_buckets"]}
                        multi={
                          this.state.reportType === "box_office_report" ||
                          this.state.reportType === "venue_transaction_report" ||
                          this.state.showEventFilter === true
                            ? false
                            : true
                        }
                        labelFormatter={b => b.name}
                        onChange={e => {
                          this.setState(
                            {
                              selectedBuckets: e,
                              selectedFilms: [],
                              selectedVenue: null,
                            },
                            () => {
                              this.componentWillReceiveProps(this.props, true);
                              if (typeof e !== "object") {
                                VenueActions.fetchAllForBucket(e)
                              }
                            }
                          );
                        }}
                      />
                    </div>
                  </div>
                ) : null}

                {this.state.reportType === "venue_transaction_report" ? (
                  <div style={{
                    width: "100%",
                    paddingTop: "25px",
                    display: "flex",
                    justifyContent: "space-between"
                  }}>
                    <div
                      style={{
                        width: "400px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "start"
                      }}
                    >
                      <div
                        style={{
                          color: "#0288d1",
                          fontWeight: "bold",
                          fontSize: "14px",
                          paddingBottom: "5px"
                        }}
                      >
                        Venue
                      </div>
                      <Select
                        clearable={false}
                        value={this.state.selectedVenue}
                        placeholder={"Select venue..."}
                        onChange={item => {
                          this.setState({
                            selectedVenue: item.value
                          });
                        }}
                        options={this.formatVenues()}
                      />
                  </div>
                  </div>
                ) : null}

                {this.state.reportType === "box_office_report" ? (
                  <div
                    style={{
                      width: "100%",
                      paddingTop: "25px",
                      display: "flex",
                      justifyContent: "space-between"
                    }}
                  >
                    <div
                      style={{
                        width: "400px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "start"
                      }}
                    >
                      <div
                        style={{
                          color: "#0288d1",
                          fontWeight: "bold",
                          fontSize: "14px",
                          paddingBottom: "5px"
                        }}
                      >
                        Film
                      </div>
                      <Select
                        clearable={false}
                        value={this.state.selectedFilms}
                        multi={true}
                        placeholder={"Select film(s)..."}
                        onChange={items => {
                          this.setState({
                            selectedFilms: items
                          });
                        }}
                        options={this.formatFilms()}
                      />
                    </div>
                  </div>
                ) : null}

                {this.state.reportType !== "venue_transaction_report" && isBoxOfficeFormat && isReportSelected ? (
                  <div style={{ marginTop: "25px", width: "100%" }}>
                    <div
                      style={{
                        color: "#0288d1",
                        fontWeight: "bold",
                        fontSize: "14px",
                        paddingBottom: "5px"
                      }}
                    >
                      Grouping
                    </div>
                    <RadioButtonGroup
                      name="grouping"
                      valueSelected={this.state.grouping}
                      onChange={(e, v) => {
                        const name = boxOfficeGroups.filter(
                          x => x.value === v
                        )[0].label;
                        this.setState({ grouping: v, groupingName: name });
                      }}
                    >
                      {boxOfficeGroups.map(item => {
                        return (
                          <RadioButton
                            style={{ display: "inline-block", width: 210 }}
                            value={item.value}
                            label={item.label}
                          />
                        );
                      })}
                    </RadioButtonGroup>
                  </div>
                ) : null}

                {this.state.reportType !== "venue_transaction_report" && !isBoxOfficeFormat && isReportSelected ? (
                  <div style={{ marginTop: "25px", width: "100%" }}>
                    <div
                      style={{
                        color: "#0288d1",
                        fontWeight: "bold",
                        fontSize: "14px",
                        paddingBottom: "5px"
                      }}
                    >
                      Grouping
                    </div>
                    <RadioButtonGroup
                      name="groupingRadioGroup"
                      valueSelected={this.state.grouping}
                      onChange={(e, v) => {
                        const name = transactionLogGroups.filter(
                          x => x.value === v
                        )[0].label;
                        this.setState({ grouping: v, groupingName: name });
                      }}
                    >
                      {transactionLogGroups.map(item => {
                        return (
                          <RadioButton
                            style={{ display: "inline-block", width: 200 }}
                            value={item.value}
                            label={item.label}
                          />
                        );
                      })}
                    </RadioButtonGroup>
                  </div>
                ) : null}

                {isReportSelected ? (
                  <div>
                    {this.state.reportType !== "box_office_report" && this.state.reportType !== "venue_transaction_report" &&
                    this.state.grouping === "NO GROUPING" ? (
                      <div>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "start",
                            paddingTop: "25px"
                          }}
                        >
                          <Checkbox
                            label="Include purchaser name and email columns"
                            checked={this.state.includeNameAndEmail}
                            onClick={e => {
                              this.setState({
                                includeNameAndEmail: e.target.checked
                              });
                            }}
                          />
                        </div>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "start",
                            paddingTop: "10px"
                          }}
                        >
                          <Checkbox
                            label="Filter by a single event"
                            checked={this.state.showEventFilter}
                            onClick={e => {
                              //adjust existing event bucket selection values
                              let selectedBuckets = [];
                              if (e.target.checked) {
                                if (this.state.selectedBuckets.length > 0) {
                                  selectedBuckets =
                                    this.state.selectedBuckets[0];
                                } else {
                                  selectedBuckets = null;
                                }
                              } else {
                                selectedBuckets = [this.state.selectedBuckets];
                                this.setState({
                                  selectedEvent: null
                                });
                              }
                              this.setState(
                                {
                                  showEventFilter: e.target.checked,
                                  selectedBuckets: selectedBuckets
                                },
                                () => {
                                  this.componentWillReceiveProps(
                                    this.props,
                                    true
                                  );
                                }
                              );
                            }}
                          />
                        </div>
                      </div>
                    ) : null}
                    {this.state.showEventFilter &&
                    this.state.grouping === "NO GROUPING" ? (
                      <div style={{ width: "100%" }}>
                        <div
                          style={{
                            color: "#0288d1",
                            paddingTop: "25px",
                            fontWeight: "bold",
                            fontSize: "14px",
                            paddingBottom: "5px",
                            width: "100%"
                          }}
                        >
                          Filter by Event
                        </div>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "start"
                          }}
                        >
                          <Select
                            multi={false}
                            clearable={false}
                            value={
                              this.state.selectedEvent
                                ? this.state.selectedEvent.id
                                : null
                            }
                            style={{ width: 450 }}
                            delimeter=","
                            onChange={item => {
                              this.setState({ selectedEvent: item });
                            }}
                            options={events}
                          />
                        </div>
                      </div>
                    ) : null}
                    {this.state.reportType !== "box_office_report" && this.state.reportType !== "venue_transaction_report" ? (
                      <div style={{ width: "100%" }}>
                        <div
                          style={{
                            color: "#0288d1",
                            paddingTop: "25px",
                            fontWeight: "bold",
                            fontSize: "14px",
                            paddingBottom: "5px",
                            width: "100%"
                          }}
                        >
                          Filter by Transaction Type
                        </div>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "start"
                          }}
                        >
                          <Select
                            multi={true}
                            clearable={false}
                            value={this.state.tType}
                            style={{ width: 250 }}
                            delimeter=","
                            onChange={item => {
                              this.setState({ tType: item });
                            }}
                            options={[
                              { value: "PAYMENT", label: "Payment" },
                              { value: "ADJUSTMENT", label: "Adjustment" },
                              { value: "REFUND", label: "Refund" }
                            ]}
                          />
                        </div>
                      </div>
                    ) : null}
                    {this.state.reportType !== "box_office_report" && this.state.reportType !== "venue_transaction_report" ? (
                      <div>
                        <div
                          style={{
                            color: "#0288d1",
                            paddingTop: "25px",
                            fontWeight: "bold",
                            fontSize: "14px",
                            paddingBottom: "5px",
                            width: "100%"
                          }}
                        >
                          Filter by Transaction Class
                        </div>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "start"
                          }}
                        >
                          <Select
                            multi={true}
                            clearable={false}
                            value={this.state.tClass}
                            style={{ width: 250 }}
                            delimeter=","
                            onChange={item => {
                              this.setState({ tClass: item });
                            }}
                            options={[
                              { value: "TICKET", label: "Ticket" },
                              { value: "INGEST", label: "Ingest" },
                              { value: "PASS", label: "Pass" },
                              { value: "ITEM", label: "Item" },
                              { value: "TAX", label: "Tax" },
                              { value: "GIFT_CARD", label: "Gift Card" }
                            ]}
                          />
                        </div>
                      </div>
                    ) : null}

                    <div style={{ marginTop: "25px" }}>
                      <div>
                        <div
                          style={{
                            color: "#0288d1",
                            fontWeight: "bold",
                            fontSize: "14px",
                            paddingBottom: "5px"
                          }}
                        >
                          {this.state.reportType === "venue_transaction_report" ? "Date" : "Date Range"}
                        </div>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "start"
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "start"
                            }}
                          >
                            <div
                              style={styles.rangeContainer}
                              ref={r => {
                                this.rangeButton = r;
                              }}
                            >
                              <RaisedButton
                                style={{ marginTop: "0px" }}
                                onClick={() =>
                                  this.setState({ showRangeEditor: true })
                                }
                                label={
                                  this.state.allTime
                                    ? "All Time – click to filter"
                                    : this.state.reportType === "venue_transaction_report" ?
                                      `${moment(this.state.selectedVenueDate).format("l")} - click to filter`
                                      : `${moment(
                                        this.state.range.startDate
                                      ).format("ll")} – ${moment(
                                        this.state.range.endDate
                                      ).format("ll")}`
                                }
                              />

                              {this.state.showRangeEditor ? (
                                <div
                                  style={styles.overlay}
                                  ref={r => {
                                    this.container = r;
                                  }}
                                >
                                  <div style={{ position: "relative" }}>
                                    {this.state.reportType === "venue_transaction_report" ?
                                      <Calendar
                                        date={this.state.selectedVenueDate}
                                        onChange={(date) => {
                                          this.setState({ selectedVenueDate: date });
                                        }}
                                      />
                                      : <DateRangePicker
                                      ranges={[this.state.range]}
                                      onChange={this.handleDateChange}
                                      maxDate={new Date()}
                                      staticRanges={[
                                        {
                                          label: "All Time",
                                          isSelected: () => false,
                                          range: () => {
                                            return {
                                              startDate: "all_time",
                                              endDate: "all_time"
                                            };
                                          }
                                        }
                                      ].concat(defaultStaticRanges)}
                                    />}
                                    <div style={styles.overlaySubmit}>
                                      <RaisedButton
                                        label="Close"
                                        onTouchTap={() =>
                                          this.setState({
                                            showRangeEditor: false
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        {this.state.reportType !== "venue_transaction_report" && <div>
                          <Checkbox
                            label="Generate Downloadable CSV Only"
                            checked={this.state.downloadCSVOnly}
                            onClick={() => this.setState(prev => ({ downloadCSVOnly: !prev.downloadCSVOnly }))}
                          />
                        </div>}
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "start"
                          }}
                        >
                          <div>
                            <RaisedButton
                              style={{ marginTop: "1em" }}
                              primary={true}
                              disabled={this.disableRunReportButton()}
                              onClick={() => {
                                if (this.state.downloadCSVOnly) {
                                  this.setState({
                                    showDownloadTempModal: true
                                  })
                                  this.submitTemporaryExport()
                                  return;
                                }
                                
                                this.setState({
                                  showSettingsPanel: false
                                });
                              }}
                              label="Run Report"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </div>

        {this.state.showSettingsPanel ? null : (
          <div>
            {this.state.grouping === "NO GROUPING" ? (
              <DataGridReportView
                selectedBuckets={this.state.selectedBuckets}
                selectedBucket={
                  this.state.selectedBuckets.length > 0
                    ? this.state.selectedBuckets[0]
                    : null
                }
                selectedFilms={[this.state.selectedFilm]}
                allTime={this.state.allTime}
                startTime={this.state.range.startDate}
                endTime={this.state.range.endDate}
                grouping={this.state.grouping}
                reportType={this.state.reportType}
                tType={this.state.tType}
                tClass={this.state.tClass}
                includeNameAndEmail={this.state.includeNameAndEmail}
                selectedEvent={this.state.selectedEvent}
              />
            ) : this.state.reportType === "box_office_report" ? (
              <BoxOfficeReportView
                selectedBucket={this.state.selectedBuckets}
                selectedFilms={this.state.selectedFilms}
                allTime={this.state.allTime}
                startTime={this.state.range.startDate}
                endTime={this.state.range.endDate}
                grouping={this.state.grouping}
                reportType={this.state.reportType}
                tType={this.state.tType}
                tClass={this.state.tClass}
              />
            ) : this.state.reportType === "venue_transaction_report" ? (
              <VenueReportView
                selectedBucket={this.state.selectedBuckets}
                selectedVenue={this.state.selectedVenue}
                allTime={false}
                startTime={this.state.selectedVenueDate}
                endTime={this.state.selectedVenueDate}
                grouping={this.state.grouping}
                reportType={this.state.reportType}
                tType={this.state.tType}
                tClass={this.state.tClass}
              />
            ) : (
              <SummaryGridReportView
                selectedBuckets={this.state.selectedBuckets}
                allTime={this.state.allTime}
                startTime={this.state.range.startDate}
                endTime={this.state.range.endDate}
                grouping={this.state.grouping}
                reportType={this.state.reportType}
                tType={this.state.tType}
                tClass={this.state.tClass}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default Radium(connectToStores(LedgerAnalytics));



// WEBPACK FOOTER //
// ./src/app/components/ledger-analytics.jsx